import { Component, OnInit, Inject } from '@angular/core';
import { FactureService } from 'src/app/service/facture.service';
import { Facture, Produit, Facturedetail, DialogData } from 'src/app/entity/Facture';
 
import { SelectionModel } from '@angular/cdk/collections';
import { Dialog } from 'primeng/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'selectprod-list',
  templateUrl: './selectprod-list.component.html'
})
export class SelectprodListComponent implements OnInit {
  selectedInvoice: Facture;
  factureDetails: Facturedetail[];
  dataSource: MatTableDataSource<Produit>;
  selection = new SelectionModel<Produit>(true, []);
  displayedColumns: string[] = ['select', 'designation', 'prixDzd', 'prixEuro', 'prixDol'];
  constructor(private invoiceService: FactureService, public dialogRef: MatDialogRef<SelectprodListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {

    this.selectedInvoice = data.invoice;
    this.invoiceService.getAllDetailFacture(this.selectedInvoice.idfacture).subscribe(result => {
      this.factureDetails = result;
      this.initList(this.selectedInvoice, this.factureDetails);
    });

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {

  }


  initList(invoice: Facture, factureDetails: Facturedetail[]) {
    let produits: number[] = [];
    let produitsShow: Produit[] = [];

    if (factureDetails)
      factureDetails.forEach(element => {
         produits.push(element.produit.produitId);
      
        
      });

    this.selectedInvoice = invoice;

    this.invoiceService.getAllProduits().subscribe(result => {
       result.forEach(element => {
        if (!produits.includes(element.produitId))
          produitsShow.push(element)

      });
      this.dataSource = new MatTableDataSource(produitsShow);


    });
  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  save() {
    this.invoiceService.selectedProduits(this.selectedInvoice.idfacture, this.selection.selected).subscribe(result => {
       this.dialogRef.close();
    });
  }


  showSeelcted() {
    //console.log(this.selection);

  }




  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }
}
